import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/**
 * Client-only discovery filters (city / search).
 * Billboard list results themselves stay in TanStack Query.
 */
type FiltersState = {
  city: string;
  search: string;
};

const initialState: FiltersState = {
  city: '',
  search: '',
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setCity(state, action: PayloadAction<string>) {
      state.city = action.payload;
    },
    setSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
    },
  },
});

export const { setCity, setSearch } = filtersSlice.actions;
export const filtersReducer = filtersSlice.reducer;
